/*
 * @Description: 邀请页面所有路由
 * @Date: 2019-07-22 16:50:00
 * @LastEditTime: 2019-07-25 10:12:09
*/

export default [
    {
        path: '/invite',
        component: resolve => require(['@/views/invite/index'], resolve),
        name: 'invite',
        meta: {
            nav: '邀请好友'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/invite.js